import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import utils from "../utils/utils";
import {PDFViewer} from '@react-pdf/renderer';
import OrderBatchBillPdfDocument from "./orderBatchBillPdfDocument";

const OrderBatchBillPdf = React.memo(({intl, orders, marketplaces, orderBatch}) => {
  const copy = utils.getOrderBatchBillPdfCopy(intl);

  return (
    <PDFViewer>
      <OrderBatchBillPdfDocument orders={orders} marketplaces={marketplaces} copy={copy} orderBatch={orderBatch}/>
    </PDFViewer>
  );
});

OrderBatchBillPdf.propTypes = {
  orders: PropTypes.array.isRequired,
  marketplaces: PropTypes.array.isRequired,
  orderBatch: PropTypes.object.isRequired,
};

OrderBatchBillPdf.defaultProps = {};

export default injectIntl(OrderBatchBillPdf);